module.exports = __webpack_public_path__ + "img/lacoste_content_img_01.6e150c8f.jpg";